import _ from 'lodash';
import { APP_IMG } from 'src/constants/index';
import styled from '@emotion/styled';
import dynamic from 'next/dynamic';
import LightGallery from 'lightgallery/react';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { NextPage } from 'next';
import { IDataLayerGlobal } from 'src/interface/data-layer';
import { NextRouter, useRouter } from 'next/router';
import { splitRote } from 'src/utils/helper';
import { IGalleryData } from 'src/interface/section';

const GalleryImage = dynamic(
  () => import('src/components/gallery/gallery-image')
);

type Props = {
  data?: any;
  eventDataLayer?: IDataLayerGlobal;
  ads?: any;
};
const WidgetGallery: NextPage<Props> = ({ data = [], eventDataLayer, ads }) => {
  if (_.isEmpty(data)) return null;
  const router: NextRouter = useRouter();
  return (
    <>
      {router?.pathname !== `${splitRote(router)}/galleries/[id]` && router?.pathname !== `${splitRote(router)}/[cid]/[id]` ? (
        <WidgetWrapper className='widget-gallery'>
          <div className='gallery-content-list'>
            <LightGallery speed={500} mode='lg-fade'>
              {data.map((item: IGalleryData, index: number) => (
                <div
                  data-src={`${APP_IMG}${item.file}`}
                  // data-poster={`${APP_IMG}/default.jpg` }
                  data-poster={item.type === 'video' ? `${APP_IMG}/default.jpg` : ''}
                  data-download-url={false}
                  key={item.id}
                  className={`gallery-content-item ${index + 1 > 4 ? '--d-none' : ''}`}
                  // ! DATALAYER

                  onClick={() =>
                    sendDataLayerGlobal({
                      ...eventDataLayer,
                      data: {
                        title: `${APP_IMG}${item.file}`,
                        index: index + 1,
                        ...eventDataLayer?.data
                      }
                    })
                  }
                >
                  <div className='item-gallery'>
                    {data?.length > 4 ? (
                      index + 1 === 4 ? (
                        <div className='more-gallery'>
                          <p>{data?.length - 4}+</p>
                        </div>
                      ) : (
                        ''
                      )
                    ) : (
                      ''
                    )}
                    {/* {item.type === 'video' ? (
                      <iframe src={`${APP_IMG}${item.file}`} loading='lazy' className='hover-shadow' />
                    ) : ( */}
                    <div className='card-image'>
                      <picture className='resolution-image'>
                        {/* <iframe src={`${APP_IMG}${item.file}`} loading='lazy' className='hover-shadow' /> */}
                        <img src={item.type === 'video' ? `${APP_IMG}/default.jpg` : `${APP_IMG}${item.file}`} alt='image-gallery' className='img-responsive hover-shadow' loading='lazy' />
                      </picture>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              ))}
            </LightGallery>
          </div></WidgetWrapper>
      ) : (
        <GalleryImage {...data} ads={ads} eventDataLayer={eventDataLayer} />
      )}
    </>
  );

};

export default WidgetGallery;

const WidgetWrapper = styled.div`
  /* default */
  .gallery-content-list {
    position: relative;
    column-count: 2;
    margin-bottom: 20px;
    .item-gallery {
      position: relative;
    }
    .more-gallery {
      background: rgba(10, 10, 10, 0.5);

      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
      pointer-events: none;
      border-radius: 8px;
      p {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-size: 26px;
        font-weight: 300;
        white-space: nowrap;
      }
    }
    .gallery-content-item {
      padding: 5px 0;
      position: relative;
      cursor: pointer;
      iframe {
        max-width: 100%;
        border-radius: 8px;
      }
      &.--d-none {
        display: none;
      }
      .card-image {
        position: relative;
        padding-top: 130%;
        background-image: url(https://image.posttoday.com/default-pic.jpg);
        border-radius: 15px;
        background-size: cover;
        background-repeat: repeat;
        .resolution-image {
          box-shadow: 0px 0px 2px 0px #b7b7b7;
          border-radius: 15px;
          position: absolute;
          width: 100% !important;
          height: 100% !important;
          top: 0;
          left: 0;
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  .gallery-content-listnews {
    position: relative;
    background-color: #fff;
    column-count: 3;
    border-radius: 15px;
    padding: 15px 20px;
    margin: 20px 0;
    @media (max-width: 690px) {
      column-count: 2;
      padding:0px 00px;
      margin: 20px 0px 0px 0px;
    }
    .item-gallery {
      position: relative;
    }
    .gallery-content-item {
      padding: 5px 0;
      position: relative;
      cursor: pointer;
      iframe {
        max-width: 100%;
        border-radius: 8px;
      }
      .card-image {
        .resolution-image {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
`;
